module.exports = __webpack_public_path__ + "img/apple_store.3f55644a.png";